export default __webpack_public_path__ + "static/media/ror.49144faa.png";